import React, { useEffect } from 'react'

import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { Tabs } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faTreePalm, faUser } from '@fortawesome/pro-solid-svg-icons'

import School from '../../../Components/school/School'
import UsersView from './UsersView/UsersView'
import Analytics from '../../../utils/analytics'
import UserActTypesDrawerProvider from '../../../Providers/Drawer/UserActTypesDrawer/UserActTypesDrawerProvider'
import HolidayPeriodsManagement from '../../../Components/school/HolidayPeriodsManagement'

const { TabPane } = Tabs

const iconStyle = { marginTop: '3px' }

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const SchoolSettingsView = ({ t }) => {
  useEffect(() => {
    Analytics.pageView('/school-settings')
  }, [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUser} style={iconStyle} />
            <div className='h-spacing' />
            {t('school_settings_view.tabs.manage_users')}
          </div>
        }
      >
        <UserActTypesDrawerProvider>
          <UsersView enableDelete />
        </UserActTypesDrawerProvider>
      </TabPane>
      <TabPane
        key='2'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faSchool} style={iconStyle} />
            <div className='h-spacing' />
            {t('school_settings_view.tabs.school_identity')}
          </div>
        }
      >
        <School />
      </TabPane>
      <TabPane
        key='3'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faTreePalm} style={iconStyle} />
            <div className='h-spacing' />
            {t('school_settings_view.tabs.manage_holiday_periods')}
          </div>
        }
      >
        <HolidayPeriodsManagement />
      </TabPane>
    </Tabs>
  )
}

export default connect(mapStateToProps)(SchoolSettingsView)
